import { render } from "./AmbassadorCard.vue?vue&type=template&id=5477df13&scoped=true"
import script from "./AmbassadorCard.vue?vue&type=script&lang=js"
export * from "./AmbassadorCard.vue?vue&type=script&lang=js"

import "./AmbassadorCard.vue?vue&type=style&index=0&id=5477df13&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_13b2cfeee597e475bd48dd409a32edc8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5477df13"]])

export default __exports__